// extracted by mini-css-extract-plugin
module.exports = {"faq":"MortgageFAQ_faq__Wu3Qt"};